<div class="shift-management-container">
  <div *ngIf="isLoading" class="loading-state">
    <mat-spinner diameter="36"></mat-spinner>
    <p>Loading shifts…</p>
  </div>

  <div *ngIf="!isLoading && shifts.length === 0" class="empty-state">
    <div class="empty-state-icon">
      <mat-icon>schedule</mat-icon>
    </div>
    <h3>No shifts configured</h3>
    <p>Create your first shift to start tracking work schedules.</p>
  </div>

  <div *ngIf="!isLoading && shifts.length > 0" class="shift-list" role="table" aria-label="Shifts">
    <div class="shift-list-head" role="row">
      <span role="columnheader">Shift</span>
      <span role="columnheader">Hours</span>
      <span role="columnheader">Days</span>
      <span role="columnheader">People</span>
      <span role="columnheader" class="shift-col-actions"><span class="sr-only">Actions</span></span>
    </div>

    <div class="shift-row" role="row" *ngFor="let shift of shifts">
      <div class="shift-cell shift-cell--name" role="cell">
        <strong>{{ shift.shift_name }}</strong>
        <span class="shift-meta">
          {{ shift.timezone }}
          <ng-container *ngIf="shift.is_overnight"> · Overnight</ng-container>
        </span>
      </div>

      <div class="shift-cell shift-cell--hours" role="cell">
        <span class="shift-hours">
          {{ shift.start_time?.substring(0, 5) || '00:00' }}–{{ shift.end_time?.substring(0, 5) || '00:00' }}
        </span>
      </div>

      <div class="shift-cell shift-cell--days" role="cell">
        <div class="working-days-pills" aria-label="Working days">
          <span class="day-pill"
            *ngFor="let dayNum of [1,2,3,4,5,6,7]"
            [class.day-pill--active]="shift.working_days.includes(dayNum)"
            [attr.title]="getDayName(dayNum)">
            {{ getDayLetter(dayNum) }}
          </span>
        </div>
      </div>

      <div class="shift-cell shift-cell--people" role="cell">
        <ng-container *ngIf="shift.employee_ids?.length > 0; else needsAssignment">
          <span class="emp-count"
            [matTooltip]="(shift.employee_count ?? shift.employee_ids?.length) + ' employees'">
            {{ shift.employee_count ?? shift.employee_ids?.length }}
          </span>
        </ng-container>
        <ng-template #needsAssignment>
          <span class="needs-assignment" matTooltip="Assign employees to this shift">Unassigned</span>
        </ng-template>
      </div>

      <div class="shift-cell shift-cell--actions" role="cell">
        <button type="button" mat-icon-button class="edit-btn" matTooltip="Edit shift"
          (click)="editShiftClicked(shift)" aria-label="Edit shift">
          <mat-icon>edit</mat-icon>
        </button>
        <button type="button" mat-icon-button class="delete-btn" matTooltip="Delete shift"
          (click)="deleteShiftClicked(shift)" aria-label="Delete shift">
          <mat-icon>delete</mat-icon>
        </button>
      </div>
    </div>
  </div>
</div>
